module.exports = __webpack_public_path__ + "img/fishHero.754693a0.png";